module.exports = __webpack_public_path__ + "static/fonts/355CC9_0_0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_0_0.woff2
// module id = 12
// module chunks = 0